import { render, staticRenderFns } from "./ReceptionPatientSelector.vue?vue&type=template&id=495d1b37&scoped=true&"
import script from "./ReceptionPatientSelector.vue?vue&type=script&lang=ts&"
export * from "./ReceptionPatientSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionPatientSelector.vue?vue&type=style&index=0&id=495d1b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d1b37",
  null
  
)

export default component.exports